import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import BootSequence from "@/pages/idevra/BootSequence";
import Console from "@/pages/idevra/Console";
import { initGamepad } from "@/lib/gamepad";
import "@/pages/idevra/idevra.css";

export default function IdevraSite() {
  const [booted, setBooted] = useState(() => localStorage.getItem("idevra_booted") === "1");
  const { slug } = useParams();
  const pathname = useLocation().pathname;
  const founderDeep = pathname.startsWith("/founder");
  const vaultDeep = pathname.startsWith("/vault");

  useEffect(() => initGamepad(), []);

  const completeBoot = () => {
    localStorage.setItem("idevra_booted", "1");
    setBooted(true);
  };

  return (
    <div className="idevra-root" data-testid="idevra-site">
      {booted && (
        <Console
          initialVentureSlug={slug}
          initialCategoryId={founderDeep ? "founder" : vaultDeep ? "vault" : undefined}
        />
      )}
      <AnimatePresence>
        {!booted && <BootSequence onComplete={completeBoot} />}
      </AnimatePresence>
    </div>
  );
}
